<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         :viewBox="viewBox"
         :aria-labelledby="iconName"
         role="presentation"
    >
        <title :id="iconName" lang="en">{{title}}</title>
        <g :fill="iconColor">
          <slot />
        </g>
  </svg>
</template>

<script>
    export default {
        props: {
            iconName: {
                type: String,
                default: 'box'
            },
            title: {
                type: String,
                default: ''
            },
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                // currentColor property that’s the default on the fill will make the icon inherit the color
                // of whatever text surrounds it
                default: 'currentColor'
            },
            minWidth: {
                type: Number,
                default: 0
            },
            minHeight: {
                type: Number,
                default: 0
            },
            viewBoxWidth: {
                type: Number,
                default: 18
            },
            viewBoxHeight: {
                type: Number,
                default: 18
            }
        },

        computed: {
            viewBox() {
                return `${this.minWidth} ${this.minHeight} ${this.viewBoxWidth} ${this.viewBoxHeight}`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/icons/IconBase.vue